// extracted by mini-css-extract-plugin
export default {"content":"prVqveBL4ZT6Gqnw1VX8"};